import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";

const warmtepompArnhemData = {
  service: 'warmtepomp',
  serviceName: 'Warmtepomp',
  location: 'arnhem',
  locationName: 'Arnhem',
  title: 'Warmtepomp Arnhem | Duurzaam Verwarmen | SOL-VI',
  description: '🏠 Warmtepomp in Arnhem ♨️ Duurzaam verwarmen ⚡ Energiezuinig 💰 Subsidie mogelijk ✅ Gratis advies. Bel: 06-55331870',
  keywords: 'warmtepomp arnhem, warmtepomp installatie arnhem, duurzaam verwarmen arnhem, energiezuinig verwarmen arnhem',
  heroText: 'Warmtepomp installatie in Arnhem. Duurzaam en energiezuinig verwarmen en koelen. Maak uw woning klaar voor de toekomst.',
  mapUrl: 'https://3dbag.nl/nl/viewer?rdx=190793.96101943016&rdy=443442.57222759165&ox=362.46657840622356&oy=656.6424872608835&oz=570.7321354615706',
  features: [
    {
      title: 'Energiezuinig',
      description: 'Tot 70% energiebesparing ten opzichte van traditionele verwarming',
      content: 'Warmtepompen gebruiken vrijwel gratis energie uit de buitenlucht.'
    },
    {
      title: 'Duurzaam',
      description: 'Milieuvriendelijke verwarming zonder fossiele brandstoffen',
      content: 'Verminder uw CO2-uitstoot en draag bij aan een betere toekomst.'
    },
    {
      title: 'Comfort',
      description: 'Verwarming én koeling in één systeem',
      content: 'Het hele jaar door optimaal comfort in uw woning.'
    }
  ],
  offers: [
    {
      name: 'Lucht-water Warmtepomp',
      description: 'Geschikt voor de meeste woningen, eenvoudige installatie',
      priceRange: '€12.000 - €18.000'
    },
    {
      name: 'Hybride Warmtepomp',
      description: 'Combinatie met cv-ketel voor optimale efficiëntie',
      priceRange: '€8.000 - €14.000'
    }
  ],
  projects: [
    {
      area: 'Arnhem-Noord',
      specs: 'Lucht-water warmtepomp 8kW',
      testimonial: 'Geweldige verwarming! Huis is nu veel comfortabeler en energierekening lager.',
      author: 'Familie Vermeer'
    },
    {
      area: 'Presikhaaf',
      specs: 'Hybride warmtepomp systeem',
      testimonial: 'Perfecte overgang van gas naar warmtepomp. Zeer tevreden!',
      author: 'Dhr. Hendriks'
    },
    {
      area: 'Arnhem-Zuid',
      specs: 'Warmtepomp met vloerverwarming',
      testimonial: 'Heerlijk warm huis en lagere energiekosten. Top!',
      author: 'Mevr. Kuipers'
    }
  ],
  ctaText: 'Klaar voor een Warmtepomp in Arnhem?',
  ctaDescription: 'Ontdek hoe een warmtepomp uw woning duurzamer en comfortabeler kan maken.'
};

const WarmtepompArnhem = () => {
  return <LocalServiceTemplate data={warmtepompArnhemData} />;
};

export default WarmtepompArnhem;